import React, { useState } from "react";
import axios from "../../utils/axiosConfig";
import { useNavigate } from "react-router-dom";
import '../styles/AdminLogin.css';

const AdminLogin = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    username: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      const res = await axios.post("/api/login", form);
  
      if (res.data.token) {
        localStorage.setItem("token", res.data.token);
        navigate("/admin");
      } else {
        alert("Invalid Login ❌");
      }
  
    } catch (err) {
      let msg = "Login failed ❌";

      if (
        err &&
        err.response &&
        err.response.data &&
        err.response.data.message
      ) {
        msg = err.response.data.message;
      }

      alert(msg);
          }
      setLoading(false);
    };

  return (
    <div className="login-wrapper">

      {/* BACK BUTTON */}
      <button className="back-btn" onClick={() => navigate("/")}>
        <i className="bi bi-arrow-left"></i> Go Back
      </button>

      <div className="login-card">

        <h2 className="login-title">Admin Login</h2>
        <p className="login-subtitle">Secure Dashboard Access</p>

        <form onSubmit={handleLogin}>

          {/* USERNAME */}
          <div className="form-group">
            <i className="bi bi-person"></i>
            <input
              type="text"
              name="username"
              value={form.username}
              onChange={handleChange}
              required
              placeholder=" "
            />
            <label>Username</label>
          </div>

          {/* PASSWORD */}
          <div className="form-group">
            <i className="bi bi-lock"></i>
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              required
              placeholder=" "
            />
            <label>Password</label>
          </div>

          {/* LOGIN BUTTON */}
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>

        </form>

      </div>
    </div>
  );
};

export default AdminLogin;